import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

export default function OwnerBrandFooter({ compact = false }) {
  return (
    <Box
      component="footer"
      sx={{
        mt: compact ? 3 : 5,
        px: compact ? 0 : 3,
        pb: compact ? 0 : 3,
      }}
    >
      <Divider sx={{ mb: 2 }} />
      <Stack spacing={0.45}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          © 2025–2026 MedEdTek. All rights reserved.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          “MedEdTek Multi-Tenant Medical Education &amp; Competency Platform” is registered with the Copyright Office, Government of India.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Medical Education • Clinical Workflow • Digital Continuity
        </Typography>
      </Stack>
    </Box>
  );
}
